import {
    type FC
} from "react";
import {
    Text as NativeText
} from "react-native";
import type IOptionRowHighlightProps from "./type";
import {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";

const OptionRowHighlight: FC<IOptionRowHighlightProps> = ({
    customTheme,
    children,
    style,
    ...props
}) => {
    const {
        typography
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        highlight: highlightDynamicStyle
    } = useStyles({
        typography
    });

    return <NativeText
        {...props}
        style={[
            style,
            highlightDynamicStyle
        ]}
    >
        {children}
    </NativeText>;
};
export default OptionRowHighlight;
